export type FilterType = {
    id: string;
    name: string;
    type: string;
    active: boolean;
}
export let filtersList: FilterType[];
filtersList = [
    {
        id: 'Complete',
        name: 'Complete',
        type: 'status',
        active: true
    },
    {
        id: 'Incomplete',
        name: 'Incomplete',
        type: 'status',
        active: true
    },
    {
        id: 'oneShot',
        name: 'One Shot',
        type: 'length',
        active: true
    },
    {
        id: 'multiChapter',
        name: 'Multi-Chapter',
        type: 'length',
        active: true
    },
    {
        id: 'sasuhina',
        name: 'Sasuke x Hinata',
        type: 'relationship',
        active: true
    },
    {
        id: 'itahina',
        name: 'Itachi x Hinata',
        type: 'relationship',
        active: true
    },
    {
        id: 'kisahina',
        name: 'Kisame x Hinata',
        type: 'relationship',
        active: true
    },
    {
        id: 'hidahina',
        name: 'Hidan x Hinata',
        type: 'relationship',
        active: true
    },
    {
        id: 'shikahina',
        name: 'Shikamaru x Hinata',
        type: 'relationship',
        active: true
    },
    {
        id: 'inohina',
        name: 'Ino x Hinata',
        type: 'relationship',
        active: true
    },
    {
        id: 'sasohina',
        name: 'Sasori x Hinata',
        type: 'relationship',
        active: true
    },
    {
        id: 'gaahina',
        name: 'Gaara x Hinata',
        type: 'relationship',
        active: true
    },
    {
        id: 'deihina',
        name: 'Deidara x Hinata',
        type: 'relationship',
        active: true
    },
    {
        id: 'leehina',
        name: 'Lee x Hinata',
        type: 'relationship',
        active: true
    },
    {
        id: 'other',
        name: 'Other',
        type: 'relationship',
        active: true
    },
]




